import React, { useState, useEffect } from "react";
import { EventBus } from "@engine/EventBus.js";
import { resolveReaction } from "@engine/combat/reactionQueue.js";
import type { PendingReaction } from "@engine/types/combat.js";

const WINDOW_MS = 1500;

/**
 * Timed overlay that appears when `combat:reaction_window` fires.
 * The player has 1.5 s to click React or Skip before the window auto-resolves.
 */
export function ReactionPrompt() {
  const [reaction, setReaction] = useState<PendingReaction | null>(null);
  const [progress, setProgress] = useState(1); // 1.0 → 0.0

  // Subscribe to EventBus
  useEffect(() => {
    const unsubOpen = EventBus.on("combat:reaction_window", (r) => {
      setReaction(r);
      setProgress(1);
    });
    const unsubClose = EventBus.on("combat:reaction_resolved", () => {
      setReaction(null);
    });
    return () => {
      unsubOpen();
      unsubClose();
    };
  }, []);

  // Countdown bar
  useEffect(() => {
    if (!reaction) return;
    const startMs = Date.now();
    const id = setInterval(() => {
      const elapsed = Date.now() - startMs;
      setProgress(Math.max(0, 1 - elapsed / WINDOW_MS));
    }, 50);
    return () => clearInterval(id);
  }, [reaction]);

  if (!reaction) return null;

  const handle = (used: boolean) => resolveReaction(reaction.eventId, used);

  return (
    <div
      style={{
        position: "fixed",
        top: "38%",
        left: "50%",
        transform: "translateX(-50%)",
        background: "rgba(10, 10, 10, 0.88)",
        color: "#fff",
        padding: "18px 24px",
        borderRadius: 6,
        textAlign: "center",
        minWidth: 220,
        pointerEvents: "auto",
        userSelect: "none",
        border: "1px solid #555",
      }}
    >
      <p style={{ margin: "0 0 10px", fontSize: 14, fontWeight: "bold" }}>
        Reaction available!
      </p>

      {/* Progress bar */}
      <div
        style={{
          background: "#333",
          height: 6,
          borderRadius: 3,
          marginBottom: 14,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            background: "#f90",
            height: "100%",
            width: `${progress * 100}%`,
            transition: "width 50ms linear",
          }}
        />
      </div>

      <div style={{ display: "flex", gap: 10, justifyContent: "center" }}>
        <button
          onClick={() => handle(true)}
          style={{ padding: "6px 16px", cursor: "pointer" }}
        >
          React
        </button>
        <button
          onClick={() => handle(false)}
          style={{ padding: "6px 16px", cursor: "pointer" }}
        >
          Skip
        </button>
      </div>
    </div>
  );
}
